import React, { useCallback, useEffect } from "react"
import { useTranslation } from "providers/i18n"

import { useTheme, Box } from "@mui/material"
import { useVenue } from "providers/venue"
import { OrdinalSelector } from "components/OrdinalSelector"
import { OrdinalSelectMenu } from "components/OrdinalSelector/OrdinalSelectMenu"
import { VenueSelector } from "components/VenueSelector"
import { SearchToggleButton } from "components/domains/search/SearchToggleButton"
import { useAppUI } from "providers/ui"
import { AmenityChipToggleGroup } from "../../../components/domains/amenities/Chip"
import { useMap } from "hooks/map/useMap"
import _ from "lodash"

export const AmenityByCategory = () => {
  const { t } = useTranslation()
  const { openSearch, isKioskMode } = useAppUI()
  const { venues, isMultiOrdinalVenue, isMultiVenueProject, dataLoaded } =
    useVenue()

  const {
    category,
    viewingOrdinal,
    viewingVenueId,
    levelInVenue,
    amenityCategoriesInVenue,
    searchParams,
    comingFromOrdinal,
    locationVenueId,
    onChangeVenue,
    findNearestOrdinal,
    setSearchParams,
    toggleAmenityFilter,
  } = useMap()

  const handleClickAmenity = useCallback(
    (amenityCategory) => {
      toggleAmenityFilter(amenityCategory)
    },
    [toggleAmenityFilter]
  )

  const onClickOrdinal = useCallback(
    (ordinal) => {
      const currentParams = Object.fromEntries(searchParams.entries())
      setSearchParams({ ...currentParams, ordinal })
    },
    [setSearchParams, searchParams]
  )

  useEffect(() => {
    const params = { venue: viewingVenueId }
    // When ordinal navigate from different page
    if (dataLoaded && !_.isNil(comingFromOrdinal)) {
      const nearestOrdinal = findNearestOrdinal(category, comingFromOrdinal)
      params.ordinal = nearestOrdinal
      setSearchParams(params)
    } else if (dataLoaded && _.isNil(viewingOrdinal)) {
      // When ordinal is not provided
      const nearestOrdinal = findNearestOrdinal(category, 0)
      setSearchParams({ ordinal: nearestOrdinal })
      params.ordinal = nearestOrdinal
      setSearchParams(params)
    }
  }, [
    dataLoaded,
    category,
    comingFromOrdinal,
    viewingVenueId,
    viewingOrdinal,
    findNearestOrdinal,
    setSearchParams,
  ])

  const theme = useTheme()
  const { styleOverrides = {} } = theme.components[`AppMap`] || {}
  const {
    searchBarContainer,
    quickLinkContainer, //TODO:: planning about quick search's working flow later
    venueSelector,
    ordinalSelectMenu,
    ordinalSelector,
  } = styleOverrides

  return (
    <>
      <Box sx={searchBarContainer}>
        {/* TODO: Find better solution for amenity quicksearch search drawer */}
        {!isKioskMode && (
          <SearchToggleButton
            placeholder={t("Search for your destination")}
            onClick={openSearch}
          />
        )}
      </Box>

      <Box sx={quickLinkContainer}>
        <AmenityChipToggleGroup
          amenities={amenityCategoriesInVenue}
          handleClickAmenity={handleClickAmenity}
        />
      </Box>
      {isMultiOrdinalVenue && (
        <Box sx={ordinalSelector}>
          <OrdinalSelector
            selectedOrdinal={Number(viewingOrdinal)}
            levels={levelInVenue}
            onClickOrdinal={onClickOrdinal}
          />
        </Box>
      )}
      {isMultiOrdinalVenue && (
        <Box sx={ordinalSelectMenu}>
          <OrdinalSelectMenu
            selectedOrdinal={Number(viewingOrdinal)}
            levels={levelInVenue}
            onChangeOrdinal={onClickOrdinal}
          />
        </Box>
      )}

      {isMultiVenueProject && (
        <Box sx={venueSelector}>
          <VenueSelector
            selectedVenue={viewingVenueId}
            venues={venues}
            onClickVenue={onChangeVenue}
            currentVenue={locationVenueId}
          />
        </Box>
      )}
    </>
  )
}
